import axios from "axios";
import { canaveral_url, sisi2_api_url } from ".";

// ========================== REGISTER ===========================
export function registerSubagent({ payload }: { payload: any }) {
  return axios.post(`${sisi2_api_url}/crm/subagents/`, payload);
}

export function uploadSubagentDocument(
  formData: FormData,
  onUploadProgress?: ((progressEvent: any) => void) | null,
) {
  return axios.post(`${canaveral_url}/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: onUploadProgress || undefined,
  });
}

export function updateSubagentDocument(uid: string, source_entity: string) {
  return axios.patch(`${canaveral_url}/documents/${uid}`, { source_entity });
}
